module.exports = {"id":"232145","name":"Bernard Berisha","rating":"72","photo":"./data/images/photos/0/232145.png","club":{"name":"Terek Grozny","logo":"./data/images/clubs/TerekGrozny.png"},"positions":["MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BernardBerisha0.json
// module id = 586
// module chunks = 0